/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SharedserviceMelcoModelsDesignListItem,
    SharedserviceMelcoModelsDesignListItemFromJSON,
    SharedserviceMelcoModelsDesignListItemFromJSONTyped,
    SharedserviceMelcoModelsDesignListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface SharedserviceMelcoModelsCreateDesignCollection
 */
export interface SharedserviceMelcoModelsCreateDesignCollection {
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsCreateDesignCollection
     */
    name?: string | null;
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsDesignListItem>}
     * @memberof SharedserviceMelcoModelsCreateDesignCollection
     */
    design_list?: Array<SharedserviceMelcoModelsDesignListItem> | null;
}

export function SharedserviceMelcoModelsCreateDesignCollectionFromJSON(json: any): SharedserviceMelcoModelsCreateDesignCollection {
    return SharedserviceMelcoModelsCreateDesignCollectionFromJSONTyped(json, false);
}

export function SharedserviceMelcoModelsCreateDesignCollectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedserviceMelcoModelsCreateDesignCollection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'design_list': !exists(json, 'design_list') ? undefined : (json['design_list'] === null ? null : (json['design_list'] as Array<any>).map(SharedserviceMelcoModelsDesignListItemFromJSON)),
    };
}

export function SharedserviceMelcoModelsCreateDesignCollectionToJSON(value?: SharedserviceMelcoModelsCreateDesignCollection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'design_list': value.design_list === undefined ? undefined : (value.design_list === null ? null : (value.design_list as Array<any>).map(SharedserviceMelcoModelsDesignListItemToJSON)),
    };
}


